const CategoryFixedIcon = (props) => (
  <svg
    width={17}
    height={17}
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.4557 7.61393H12.0391C10.3249 7.61393 9.38281 6.67185 9.38281 4.95768V3.54102C9.38281 1.82685 10.3249 0.884766 12.0391 0.884766H13.4557C15.1699 0.884766 16.112 1.82685 16.112 3.54102V4.95768C16.112 6.67185 15.1699 7.61393 13.4557 7.61393ZM12.0391 1.94727C10.9199 1.94727 10.4453 2.42185 10.4453 3.54102V4.95768C10.4453 6.07685 10.9199 6.55143 12.0391 6.55143H13.4557C14.5749 6.55143 15.0495 6.07685 15.0495 4.95768V3.54102C15.0495 2.42185 14.5749 1.94727 13.4557 1.94727H12.0391Z'
      fill='currentColor'
    />
    <path
      d='M4.95573 16.1149H3.53906C1.8249 16.1149 0.882812 15.1728 0.882812 13.4587V12.042C0.882812 10.3278 1.8249 9.38574 3.53906 9.38574H4.95573C6.6699 9.38574 7.61198 10.3278 7.61198 12.042V13.4587C7.61198 15.1728 6.6699 16.1149 4.95573 16.1149ZM3.53906 10.4482C2.4199 10.4482 1.94531 10.9228 1.94531 12.042V13.4587C1.94531 14.5778 2.4199 15.0524 3.53906 15.0524H4.95573C6.0749 15.0524 6.54948 14.5778 6.54948 13.4587V12.042C6.54948 10.9228 6.0749 10.4482 4.95573 10.4482H3.53906Z'
      fill='currentColor'
    />
    <path
      d='M4.2474 7.61393C2.39156 7.61393 0.882812 6.10518 0.882812 4.24935C0.882812 2.39352 2.39156 0.884766 4.2474 0.884766C6.10323 0.884766 7.61198 2.39352 7.61198 4.24935C7.61198 6.10518 6.10323 7.61393 4.2474 7.61393ZM4.2474 1.94727C2.97948 1.94727 1.94531 2.98143 1.94531 4.24935C1.94531 5.51727 2.97948 6.55143 4.2474 6.55143C5.51531 6.55143 6.54948 5.51727 6.54948 4.24935C6.54948 2.98143 5.51531 1.94727 4.2474 1.94727Z'
      fill='currentColor'
    />
    <path
      d='M12.7474 16.1149C10.8916 16.1149 9.38281 14.6062 9.38281 12.7503C9.38281 10.8945 10.8916 9.38574 12.7474 9.38574C14.6032 9.38574 16.112 10.8945 16.112 12.7503C16.112 14.6062 14.6032 16.1149 12.7474 16.1149ZM12.7474 10.4482C11.4795 10.4482 10.4453 11.4824 10.4453 12.7503C10.4453 14.0182 11.4795 15.0524 12.7474 15.0524C14.0153 15.0524 15.0495 14.0182 15.0495 12.7503C15.0495 11.4824 14.0153 10.4482 12.7474 10.4482Z'
      fill='currentColor'
    />
  </svg>
);
export default CategoryFixedIcon;
